import { SvgProps } from "../../types";

const Power = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={26}
    fill="none"
    {...props}>
    <path
      fill="#1280E7"
      d="m8.62 20.656 6.469-7.75h-5l.906-7.094-5.781 8.344h4.344l-.938 6.5Zm-3.187 4.75 1.25-8.75H.433L11.683.406h2.5l-1.25 10h7.5l-12.5 15h-2.5Z"
    />
    <path
      stroke="#fff"
      strokeOpacity={0.75}
      strokeWidth={0.5}
      d="m8.373 20.62-.126.874.565-.678 6.469-7.75.342-.41h-5.25l.87-6.812-.453-.174-5.782 8.344-.271.392h4.532l-.896 6.215ZM5.72 25.157l1.21-8.464.04-.286H.91L11.814.656h2.085l-1.214 9.72-.036.28h7.25l-12.083 14.5H5.72Z"
    />
  </svg>
);
export default Power;
